module.exports = __webpack_public_path__ + "media/images/writer/emailer/instagram-icon-47d5c04d11ed50b30cb2b5b84bd88206.png";